import { render, staticRenderFns } from "./FamilyTable.vue?vue&type=template&id=14f84609&scoped=true&lang=pug"
import script from "./FamilyTable.vue?vue&type=script&lang=ts"
export * from "./FamilyTable.vue?vue&type=script&lang=ts"
import style0 from "./FamilyTable.vue?vue&type=style&index=0&id=14f84609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f84609",
  null
  
)

export default component.exports